// extracted by mini-css-extract-plugin
export default {"big_card":"BigCardBanner_big_card__VDp1M","link":"BigCardBanner_link__uBZh-"};